export const commissionInfo = {
  from: "From",
  to: "To",
  accountName: "Account Name",
  username: "Username",
  winLoss: "Win/Loss",
  bet: "Bet",
  validBet: "Valid Bet",
  settle: "Settle",
  topup: "Topup",
  withdraw: "Withdraw",
  rtbDeposit: "RTB Deposit",
  rtbWithdraw: "RTB Withdraw",
  viewDetail: "VIEW DETAIL",
  details: "Details",
  commission: "COMMISSION",
  startDate: "START DATE",
  endDate: "END DATE",
  close: "close",
  viewUser: "view user",
};
